import React from 'react';
import { MonitorX, LogIn } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  onContinue: () => void;
}

export function SessionRevokedModal({ onContinue }: Props) {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background">
      <div className="flex flex-col items-center justify-center text-center p-8 max-w-md mx-auto">
        <div className="w-24 h-24 rounded-full bg-destructive/20 flex items-center justify-center mb-6">
          <MonitorX className="w-12 h-12 text-destructive" />
        </div>
        <h1 className="text-3xl font-bold text-foreground mb-3">
          Sessão encerrada
        </h1>
        <p className="text-muted-foreground text-lg mb-3">
          Sua sessão foi encerrada porque outro dispositivo entrou na sua conta.
        </p>
        <p className="text-sm text-muted-foreground mb-8">
          O Forja Hub permite apenas <strong>1 computador</strong> e <strong>1 celular</strong> conectados ao mesmo tempo.
          Se não foi você, troque sua senha imediatamente.
        </p>
        <Button onClick={onContinue} className="gap-2">
          <LogIn className="w-4 h-4" />
          Entrar novamente
        </Button>
      </div>
    </div>
  );
}